import { stringify } from 'flatted'

/**
 * Custom console logger that includes caller file path, line number,
 * and stringifies data using flatted.
 *
 * @param message - The message to log.
 * @param data - Optional data object to log.
 */
export const logFormattedMessage = (message, data) => {
  let filePath = 'unknown file'
  let lineNumber = 'unknown line'

  try {
    const stack = new Error().stack
    if (stack) {
      // Splitting by newline and taking the 3rd line (index 2) is common.
      // Adjust if necessary based on environment/build tools.
      // 0: Error
      // 1: at logFormattedMessage (current function)
      // 2: at <caller function>
      const callerLine = stack.split('\n')[2]?.trim()

      if (callerLine) {
        // Regex to attempt to extract path and line number
        // This regex tries to capture:
        // - path within parentheses (e.g., http://localhost:5173/src/App.tsx?t=1700000000:25:10)
        // - or path without parentheses if it's a direct file path (e.g., /path/to/file.js:25:10)
        const match = callerLine.match(/at (?:.*?\((.*?):(\d+):(\d+)\)|(.*?):(\d+):(\d+))/)
        if (match) {
          filePath = match[1] || match[4] || 'unknown path'
          lineNumber = match[2] || match[5] || 'unknown line'
        } else {
          // Fallback if regex doesn't match, try simpler parsing
          const pathParts = callerLine.substring(callerLine.indexOf('at ') + 3)
          const lastColon = pathParts.lastIndexOf(':')
          if (lastColon > -1) {
            const secondLastColon = pathParts.lastIndexOf(':', lastColon - 1)
            if (secondLastColon > -1) {
              filePath = pathParts.substring(0, secondLastColon)
              lineNumber = pathParts.substring(secondLastColon + 1, lastColon)
            }
          }
        }
      }
    }
  } catch (e) {
    console.error('Error getting caller information for logger:', e)
  }

  const dataString = data ? stringify(data, undefined, 2) : ''

  console.log(
    `[${new Date().toISOString()}] [${filePath}:${lineNumber}] ${message}`,
    dataString ? `\nData: ${dataString}` : '',
  )
}

// Example Usage (can be removed or kept for testing):
// const myFunction = () => {
//   logFormattedMessage('This is a test message from myFunction', { a: 1, b: { c: 2 } });
// };
//
// const anotherFunction = () => {
//   myFunction();
// };
//
// anotherFunction();
